const gameContributions = [
	{
		path: '/community/games/contributions',
		name: 'community-game-contributions-list',
		component: () => import('@/views/community/game-contributions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,moderation',
		},
	},
]

export default gameContributions
